import React, { useState, useEffect } from "react";
import styled, { keyframes, css } from "styled-components";
import { MainTitle } from '../Typography/titles';
import { Reveal } from '../Reveal';
import axios from "axios";

function Carroussel() {
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    // Your provided JSON data
    const data =
      [{ "_id": "64fec786be4a52b1d2dbc51d", "name": "logo1", "logoUrl": "https://res.cloudinary.com/dec07srhw/image/upload/v1694418526/63a3137afa137fcfca43f8b3_Rectangle_simple_original_mvr6ao.png", "__v": 0 }, { "_id": "64fec79cbe4a52b1d2dbc51f", "name": "logo2", "logoUrl": "https://res.cloudinary.com/dec07srhw/image/upload/v1694418526/Black-Decker-Logo-1536x960_nwd7fj.png", "__v": 0 }, { "_id": "64fec7c6be4a52b1d2dbc521", "name": "logo3", "logoUrl": "https://res.cloudinary.com/dec07srhw/image/upload/v1694418527/bsh_bosch_und_siemens_hausgerate_logo.svg_nzz82r.png", "__v": 0 }, { "_id": "64fec7dcbe4a52b1d2dbc523", "name": "logo4", "logoUrl": "https://res.cloudinary.com/dec07srhw/image/upload/v1694418527/jaguar_epgq3e.png", "__v": 0 }, { "_id": "64fec80bbe4a52b1d2dbc525", "name": "logo5", "logoUrl": "https://res.cloudinary.com/dec07srhw/image/upload/v1694418528/bmw-logo-0_lbditv.png", "__v": 0 }, { "_id": "64fec828be4a52b1d2dbc527", "name": "logo6", "logoUrl": "https://res.cloudinary.com/dec07srhw/image/upload/v1694418528/edf-logo-1_zqmwlv.png", "__v": 0 }, { "_id": "64fec84bbe4a52b1d2dbc529", "name": "logo7", "logoUrl": "https://res.cloudinary.com/dec07srhw/image/upload/v1694418528/logo_ci_liebherr_fl_z90j6o.png", "__v": 0 }, { "_id": "64fec85ebe4a52b1d2dbc52b", "name": "logo8", "logoUrl": "https://res.cloudinary.com/dec07srhw/image/upload/v1694418528/audi-logo-10_qls2ti.png", "__v": 0 }, { "_id": "64fec874be4a52b1d2dbc52d", "name": "logo9", "logoUrl": "https://res.cloudinary.com/dec07srhw/image/upload/v1694418529/logo-atlantic_1_fjuk3z.png", "__v": 0 }, { "_id": "64fec899be4a52b1d2dbc52f", "name": "logo10", "logoUrl": "https://res.cloudinary.com/dec07srhw/image/upload/v1694418529/logo-stellantis_hgzpg3.png", "__v": 0 }, { "_id": "64fec8bebe4a52b1d2dbc531", "name": "logo11", "logoUrl": "https://res.cloudinary.com/dec07srhw/image/upload/v1694418529/mclaren-logo_lyp7zb.png", "__v": 0 }, { "_id": "64fec8d3be4a52b1d2dbc533", "name": "logo12", "logoUrl": "https://res.cloudinary.com/dec07srhw/image/upload/v1694418530/mini-logo_giv7w3.png", "__v": 0 }, { "_id": "64fec915be4a52b1d2dbc535", "name": "logo13", "logoUrl": "https://res.cloudinary.com/dec07srhw/image/upload/v1694418530/overkiz-logo-header_mobile_s1ybho.png", "__v": 0 }, { "_id": "64fec929be4a52b1d2dbc537", "name": "logo14", "logoUrl": "https://res.cloudinary.com/dec07srhw/image/upload/v1694418530/Mitsubishi-logo-3_mfcykj.png", "__v": 0 }, { "_id": "64fec947be4a52b1d2dbc539", "name": "logo15", "logoUrl": "https://res.cloudinary.com/dec07srhw/image/upload/v1694418531/RENAULT-01_qnqt5y.png", "__v": 0 }, { "_id": "64fec977be4a52b1d2dbc53d", "name": "logo17", "logoUrl": "https://res.cloudinary.com/dec07srhw/image/upload/v1694418532/Schneider_Electric-Logo.wine_cdcqhg.png", "__v": 0 }, { "_id": "64fec989be4a52b1d2dbc53f", "name": "logo18", "logoUrl": "https://res.cloudinary.com/dec07srhw/image/upload/v1694418532/Somfy_logo_3547688_4319208_1563029_1690741_1581425_6494311-545x148_ekxuxs.png", "__v": 0 }, { "_id": "64fec9a6be4a52b1d2dbc541", "name": "logo19", "logoUrl": "https://res.cloudinary.com/dec07srhw/image/upload/v1694418532/seat-logo-0_cnrnmu.png", "__v": 0 }, { "_id": "64fec9b6be4a52b1d2dbc543", "name": "logo20", "logoUrl": "https://res.cloudinary.com/dec07srhw/image/upload/v1694418533/mercedes-benz-logo-0_pohli1.png", "__v": 0 }, { "_id": "64fec9c5be4a52b1d2dbc545", "name": "logo21", "logoUrl": "https://res.cloudinary.com/dec07srhw/image/upload/v1694418534/volkswagen_usekyn.png", "__v": 0 }, { "_id": "64fec9e5be4a52b1d2dbc547", "name": "logo22", "logoUrl": "https://res.cloudinary.com/dec07srhw/image/upload/v1694418535/scania-logo_kqkcqh.png", "__v": 0 }]
    // ... add all other partner objects here


    // Processing the data
    const logoUrls = data.map((partner) => partner.logoUrl);

    const row1 = logoUrls.slice(0, 7);
    const row2 = logoUrls.slice(7, 14);
    const row11 = logoUrls.slice(14, 21);
    const row22 = logoUrls.slice(15, 20);

    setPartners({ row1, row11, row2, row22 });

  }, []);


  if (!partners.row1 || !partners.row11 || !partners.row2 || !partners.row22) {
    return <div>Loading...</div>;
  }
  return (
    <Reveal>
      <AppContainer>
        <Wrapper>
          <Reveal>
            <MainTitle titleText='Our Final Clients' text="Serving world-class industry leaders" />
          </Reveal>
          <Marquee>
            <MarqueeGroup>
              {partners.row1.map((el, index) => (
                <ImageGroup key={index}>
                  <Image src={el} />
                </ImageGroup>
              ))}
            </MarqueeGroup>
            <MarqueeGroup>
              {partners.row1.map((el, index) => (
                <ImageGroup key={index}>
                  <Image src={el} />
                </ImageGroup>
              ))}
            </MarqueeGroup>
          </Marquee>
          <Marquee>
            <MarqueeGroup2>
              {partners.row2.map((el, index) => (
                <ImageGroup key={index}>
                  <Image src={el} />
                </ImageGroup>
              ))}
            </MarqueeGroup2>
            <MarqueeGroup2>
              {partners.row2.map((el, index) => (
                <ImageGroup key={index}>
                  <Image src={el} />
                </ImageGroup>
              ))}
            </MarqueeGroup2>
          </Marquee>
          <Marquee>
            <MarqueeGroup>
              {partners.row11.map((el, index) => (
                <ImageGroup key={index}>
                  <Image src={el} />
                </ImageGroup>
              ))}
            </MarqueeGroup>
            <MarqueeGroup>
              {partners.row11.map((el, index) => (
                <ImageGroup key={index}>
                  <Image src={el} />
                </ImageGroup>
              ))}
            </MarqueeGroup>
          </Marquee>

        </Wrapper>
      </AppContainer>
    </Reveal>
  );
}

export default Carroussel;

const AppContainer = styled.div`

`;

const Wrapper = styled.div`
  width: 100%;
  height: fit-content;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const Marquee = styled.div`
  display: flex;
  width: 100vw;
  overflow: hidden;
  user-select: none;

  mask-image: linear-gradient(
    to right,
    hsl(0 0% 0% / 0),
    hsl(0 0% 0% / 1) 10%,
    hsl(0 0% 0% / 1) 90%,
    hsl(0 0% 0% / 0)
  );
`;

const scrollX = keyframes`
  from {
    left: translateX(0);
  }
  to {
    transform: translateX(-100%);
  }
`;
const scroll2 = keyframes`
0% {
  transform: translateX(-100%);
}
100% {
  transform: translateX(0%);
}
`;


const common = css`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-around;
  white-space: nowrap;
  width: 100%;
  animation: ${scrollX} 30s linear infinite;
  @media (max-width: 1100px) {
    ${css`
width:700px;
    
    `}
`;
const common2 = css`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-around;
  white-space: nowrap;
  width: 100%;
  animation: ${scroll2} 30s linear infinite;
  @media (max-width: 1100px) {
    ${css`
width:700px;
    
    `}
`;
const MarqueeGroup = styled.div`
  ${common}
`;
const MarqueeGroup2 = styled.div`
  ${common2}
  animation-direction: reverse;
  animation-delay: -3s;
`;

const ImageGroup = styled.div`
  display: grid;
  place-items: center;
  width: clamp(10rem, 1rem + 40vmin, 30rem);
  padding: calc(clamp(10rem, 1rem + 30vmin, 30rem) / 10);

    @media (max-width: 1100px) {
    ${css`
padding:0;
    
    `}
`;

const Image = styled.img`
  object-fit: contain;
  width: 170%;
  height: 100%;
  /* border: 1px solid black; */
  border-radius: 0.5rem;
  aspect-ratio: 16/9;
  padding: 5px 10px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
`;
